export default __webpack_public_path__ + "static/media/dog2.40c67153.png";